module.exports = __webpack_public_path__ + "media/images/flags/1x1/dma-6a522ff1b9197e66eb3b70e3743a00df.svg";